import { useTranslation } from "react-i18next";
import { categories } from "@/data/categories";

export default function CategoryGrid() {
  const { t } = useTranslation();

  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            {t("categories.title")}
          </h2>
          <p className="text-foreground-600 max-w-2xl mx-auto">{t("categories.subtitle")}</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4">
          {categories.map((c) => (
            <a
              key={c.name}
              href={c.url}
              target="_blank"
              rel="noopener nofollow"
              className="group rounded-lg border border-background-200 bg-background-50 overflow-hidden hover:border-primary-300 transition"
            >
              <div className="relative h-32 md:h-36 overflow-hidden">
                <img
                  src={c.image}
                  alt={`${c.name} — USFans Spreadsheet`}
                  title={`${c.name} on USFans Spreadsheet`}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="flex items-center justify-between px-3 py-3">
                <span className="text-sm font-semibold text-foreground-800 whitespace-nowrap truncate">
                  {c.name}
                </span>
                <span className="w-6 h-6 flex items-center justify-center text-foreground-400 group-hover:text-primary-600 transition shrink-0">
                  <i className="ri-arrow-right-up-line"></i>
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}